module.exports = __webpack_public_path__ + "static/media/fye-hand-right.5ced56df.png";